import React, { SFC } from "react";
import withTheme, { PropsType as withThemeProps } from "../../hoc/withTheme";
import Icon from "../Icon";
import "./style.scss";

type PropsType = withThemeProps & {
    title: string;
    inverted?: boolean;
    target?: string;
    url?: string;
    action?(): void;
};

const Button = (props: PropsType): SFC => {
    const element = props.url !== undefined && props.url.length > 0 ? "a" : "button";
    let className = "Button";

    if (props.theme.fill !== "inherit") {
        className += " Button--themed";
    }

    if (props.theme.type === "light") {
        className += " Button--light";
    }

    if (props.inverted) {
        className += " Button--inverted";
    }

    const target = props.target ? "_self" : props.target;

    const handleClick = (): void => {
        if (props.action) props.action();
    };

    return props.url !== undefined && props.url.length > 0 ? (
        <a
            href={props.url}
            className={className}
            target={props.target}
            title={props.title}
            style={{ color: props.theme.fill }}
        >
            {props.icon && (
                <div className="Button__icon">
                    <Icon icon={props.icon} />
                </div>
            )}
            <div className="Button__label">{props.children}</div>
        </a>
    ) : (
        <button
            onClick={handleClick}
            type="button"
            className={className}
            title={props.title}
            style={{ color: props.theme.fill }}
        >
            {props.icon && (
                <div className="Button__icon">
                    <Icon icon={props.icon} />
                </div>
            )}
            <div className="Button__label">{props.children}</div>
        </button>
    );
};

export default withTheme(Button);
export { PropsType };
